<template>
  <v-card
    class="mx-auto"
    style="box-shadow: 0 8px 32px rgb(47 60 74 / 1%), 0 8px 16px rgb(47 60 74 / 2%)"
    :class="{'pa-4': padding, cardClass}"
    :color="color"
    max-width="100%"
    :disabled="disabling"
  >
    <v-skeleton-loader
      height="100%"
      width="100%"
      type="card"
      :loading="loading"
    >
      <slot />
    </v-skeleton-loader>
  </v-card>
</template>

<script>
  export default {
    name: 'Card',
    props: {
      color: {
        type: String,
        default: 'white',
      },
      cardClass: {
        type: String,
        default: '',
      },
      padding: {
        type: Boolean,
        default: false,
      },
      disabling: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      loading () {
        return this.$store.getters.isDataLoaded
      },
    },
  }
</script>
